export const BOTTOM_BUTTON_LABELS = {
  en: {
    review: 'Review',
    start: 'Start Fundraiser',
    submit: 'Submit for Approval',
    next: 'Register NGO'
  },
  hi: {
    review: 'समीक्षा करें',
    start: 'फंडरेज़र शुरू करें',
    submit: 'स्वीकृति के लिए सबमिट करें',
    next: 'NGO पंजीकरण करें'
  },
  ta: {
    review: 'மீளாய்வு',
    start: 'நிதி திரட்டலை துவங்கு',
    submit: 'அனுமதிக்காக சமர்ப்பிக்கவும்',
    next: 'என்ஜிஒவை பதிவு செய்யுங்கள்'
  },
  te: {
    review: 'సమీక్షించండి',
    start: 'ఫండ్రైజర్ ప్రారంభించండి',
    submit: 'ఆమోదం కోసం సమర్పించండి',
    next: 'ఎన్జీఓను నమోదు చేయండి'
  }
};
